import { FAQS } from "../lib/constants";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export function FAQ() {
  return (
    <section id="faq" className="section faq-section" data-testid="faq-section">
      <div className="section-heading" data-testid="faq-heading">
        <span className="section-eyebrow" data-testid="faq-eyebrow">Perguntas frequentes</span>
        <h2 data-testid="faq-title">Dúvidas rápidas sobre guincho em Arujá</h2>
      </div>
      <Accordion type="single" collapsible className="faq-accordion" data-testid="faq-accordion">
        {FAQS.map(([question, answer], index) => (
          <AccordionItem value={`item-${index}`} key={question} data-testid={`faq-item-${index}`}>
            <AccordionTrigger data-testid={`faq-trigger-${index}`}>{question}</AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${index}`}>{answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}